// extracted by mini-css-extract-plugin
module.exports = {"main":"outpatientReport_main__UKlr8","tabs":"outpatientReport_tabs__1FHjF"};